
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AllocationProjectFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AllocationProject"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"allocationName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"allocationDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"prefillOption"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"orgStructurePITOption"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"baselineDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isActive"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"forecast"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"workingDays"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isRequestorPlannerReadonly"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"requestorPlannerReadonlyBanner"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"requestorPlannerReadonlyHover"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isApproverPlannerReadonly"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"approverPlannerReadonlyBanner"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"approverPlannerReadonlyHover"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shouldVerifyObjectives"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"disablePlannerRequirementInput"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"disablePrefillFutureForecastFromPrevious"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enableRequirementInput"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enableDecimalFTEInput"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enableRequestorForecastConstraint"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enableApproverForecastConstraint"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enableRealtimeAllocation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"announcements"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"messageType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"endDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"content"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"isRequestorForecastReadonly"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"requestorForecastReadonlyBanner"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"requestorForecastReadonlyHover"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isApproverForecastReadonly"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"approverForecastReadonlyBanner"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"approverForecasteadonlyHover"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"forecastBudgetColumnName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"forecastBudgetColumnTooltip"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"forecastBudgetDeltaColumnName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"forecastBudgetDeltaColumnTooltip"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"baselineColumnName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"baselineColumnTooltip"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"requestorColumnName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"requestorColumnTooltip"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"approverColumnName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"approverColumnTooltip"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":1191}};
    doc.loc.source = {"body":"fragment AllocationProjectFragment on AllocationProject {\n  id\n  allocationName\n  startDate\n  allocationDate\n  prefillOption\n  orgStructurePITOption\n  baselineDate\n  isActive\n  forecast\n  workingDays\n  isRequestorPlannerReadonly\n  requestorPlannerReadonlyBanner\n  requestorPlannerReadonlyHover\n  isApproverPlannerReadonly\n  approverPlannerReadonlyBanner\n  approverPlannerReadonlyHover\n  shouldVerifyObjectives\n  disablePlannerRequirementInput\n  disablePrefillFutureForecastFromPrevious\n  enableRequirementInput\n  enableDecimalFTEInput\n  enableRequestorForecastConstraint\n  enableApproverForecastConstraint\n  enableRealtimeAllocation\n  announcements {\n    isActive\n    messageType\n    startDate\n    endDate\n    content\n    description\n  }\n  isRequestorForecastReadonly\n  requestorForecastReadonlyBanner\n  requestorForecastReadonlyHover\n  isApproverForecastReadonly\n  approverForecastReadonlyBanner\n  approverForecasteadonlyHover\n  forecastBudgetColumnName\n  forecastBudgetColumnTooltip\n  forecastBudgetDeltaColumnName\n  forecastBudgetDeltaColumnTooltip\n  baselineColumnName\n  baselineColumnTooltip\n  requestorColumnName\n  requestorColumnTooltip\n  approverColumnName\n  approverColumnTooltip\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["AllocationProjectFragment"] = oneQuery(doc, "AllocationProjectFragment");
        
